export var PACKAGE_VERSION = '3.0.0 (ddab42e1)';
export var THEME = 'polaris';
